// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .pl-err-p[data-v-42dacd73]{width:100%!important;height:50px!important;background-color:#000!important}#aw--c #aw-sl .img-box[data-v-42dacd73]{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important;position:relative!important}", ""]);
// Exports
module.exports = exports;
